/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useTranslation } from 'next-i18next';
import styles from '@components/Checkbox/Checkbox.styles';
import { TProps } from '@components/Checkbox/typescript';
import Icon from '@components/icons/Icon';
import Check from '@components/icons/components/Check';
const Checkbox = ({
  value,
  onChange = () => undefined,
  children,
  addSx = {},
  name = '',
  showError = false,
  error = '',
  readonly = false,
  disabled = false,
  cy
}: TProps) => {
  const {
    t
  } = useTranslation('common');
  const onClick = () => {
    if (readonly || disabled) return;
    if (onChange) onChange(!value);
  };
  return <div sx={styles.checkboxWrapper} data-cy={cy}>
      <div className="checkbox-container" sx={{
      ...styles.checkboxContainer,
      ...addSx
    }} onClick={onClick}>
        <input type="checkbox" sx={styles.hiddenCheckbox} name={name} checked={value} readOnly />
        <span className="checkbox-checkmark" sx={styles.checkMarkContainer(value, showError, disabled)}>
          <Icon color="neutralWhite" addSx={styles.checkMarkIcon(value, readonly, disabled)}>
            <Check />
          </Icon>
        </span>
        <label className="checkbox-label" htmlFor={name} sx={styles.checkboxLabel}>
          {children}
        </label>
      </div>
      <div className="checkbox-error" sx={styles.error(showError && error.length > 0)}>
        {showError && t(`${error}`)}
      </div>
    </div>;
};
export default Checkbox;